import React, {Component} from 'react'
import {
    Card,
    Table,
    Button,
    Tag,
    message,
    Modal,
    Radio
} from 'antd';
import {getAllFreshJourneyUserMakeTypes, changeKpiMakingType} from '../../request'
import {withRouter} from "react-router-dom";

let columnsKey = {
    index:'序号',
    userName: '员工',
    periodStart: '旅程开始时间',
    periodEnd: '旅程结束时间',
    kpiMakeType: '填报方式',
    actions: '操作',
}

class FreshJourneyKpiMaking extends Component {
    state = {
        dataSource:[],
        columns:[],
        loading:false,
        editModalVisible: false,
        currentRecord: null,
        selectedKpiMakingType: null,
    };

    createColumns = (createKeys)=>{
        let columns = Object.keys(createKeys).map(item=>{
            let initObj = {
                title:createKeys[item],
                dataIndex:item,
                key:item,
                align:'left'
            }
            if(item=='index'){
                return {
                    ...initObj,
                    align:'center',
                    width:80,
                    render:(text,record,index)=>{
                        return index+1
                    }
                }
            }else if(item=='kpiMakeType'){
                return {
                    ...initObj,
                    align:'center',
                    width:150,
                    render:(text,record,index)=> {
                        return (
                            <>
                                {text == 1 ? 
                                    <Tag color="blue">Leader制定</Tag> : 
                                    <Tag color="green">员工制定</Tag>
                                }
                            </>
                        )
                    }
                }
            }else if(item=='periodStart' || item=='periodEnd'){
                return {
                    ...initObj,
                    align:'center',
                    width:150,
                }
            }else if(item=='userName'){
                return {
                    ...initObj,
                    align:'center',
                    width:120,
                }
            }else if(item=='actions'){
                return {
                    ...initObj,
                    fixed: 'right',
                    align:'center',
                    width: 150,
                    render: (text, record, index) => {
                        return (
                            <>
                                <Button 
                                    type="link" 
                                    size="small"
                                    onClick={() => this.showEditModal(record)}
                                >
                                    修改填报方式
                                </Button>
                            </>
                        )
                    }
                }
            }else{
                return initObj
            }
        })
        this.setState({
            columns,
        })
    }

    initTableDataList(){
        this.setState({ loading: true });
        getAllFreshJourneyUserMakeTypes({}).then(res=>{
            this.setState({
                loading: false,
                dataSource:res,
            })
        }).catch(err=>{
            this.setState({
                loading: false,
            })
        })
    }

    showEditModal = (record) => {
        this.setState({
            editModalVisible: true,
            currentRecord: record,
            selectedKpiMakingType: record.kpiMakeType
        })
    }

    handleEditCancel = () => {
        this.setState({
            editModalVisible: false,
            currentRecord: null,
            selectedKpiMakingType: null
        })
    }

    handleKpiMakingTypeChange = (e) => {
        this.setState({
            selectedKpiMakingType: e.target.value
        })
    }

    handleEditConfirm = () => {
        const { currentRecord, selectedKpiMakingType } = this.state;
        
        if(!currentRecord || selectedKpiMakingType === null){
            message.warning('请选择填报方式');
            return;
        }

        this.setState({ loading: true });
        
        changeKpiMakingType({
            userId: currentRecord.userId,
            kpiType: 1,  // 固定传1
            kpiMakingType: selectedKpiMakingType
        }).then(res => {
            message.success('修改成功');
            this.setState({
                editModalVisible: false,
                currentRecord: null,
                selectedKpiMakingType: null,
            });
            this.initTableDataList();
        }).catch(err => {
            this.setState({ loading: false });
        })
    }

    componentDidMount(){
        this.createColumns(columnsKey);
        this.initTableDataList()
    }

    render() {
        const { dataSource, columns, loading, editModalVisible, selectedKpiMakingType } = this.state;

        return (
            <>
                <Card 
                    title={'新人之旅员工KPI制定方式'} 
                    bordered={false} 
                    className={'card-fixed-head-wrap'}
                >
                    <Table
                        bordered={true}
                        size="small"
                        pagination={false}
                        dataSource={dataSource}
                        columns={columns}
                        rowKey={(record) => record.userId}
                        loading={loading}
                    />
                </Card>

                <Modal
                    title="修改填报方式"
                    open={editModalVisible}
                    onOk={this.handleEditConfirm}
                    onCancel={this.handleEditCancel}
                    okText="确定"
                    cancelText="取消"
                >
                    <Radio.Group 
                        onChange={this.handleKpiMakingTypeChange} 
                        value={selectedKpiMakingType}
                    >
                        <Radio value={1}>Leader制定</Radio>
                        <Radio value={2}>员工制定</Radio>
                    </Radio.Group>
                </Modal>
            </>
        )
    }
}

export default withRouter(FreshJourneyKpiMaking)

